export default {};

export const PATH_MAP = {
  forms: '/exports/data/forms',
  timeEntries: '/exports/data/tasks',
  boardCards: '/exports/data/boardCards',
};

export const fixedDecimalKeys = [
  'cost',
  'totalHours',
  'workHours',
  'breakHours',
  'regularHours',
  'otHours',
  'doubleOT',
  'saturdayTime',
  'saturdayOT',
  'saturdayDoubleOT',
  'sundayTime',
  'sundayOT',
  'sundayDoubleOT',
  'burdenCost',
  'calculatedWage',
  'user.wage',
  'costcodes.hourlywage',
  'class.hourlywage',
];

export const LINE_NUMBER_COLUMN = {
  title: '',
  render: (_1, _2, index) => index + 1,
  width: 75,
};
export const DATE_FORMAT_MAP = {
  'mm/dd/yyyy': 'LL/dd/yyyy',
  'mm/dd/yy': 'LL/dd/yy',
  'dd/mm/yyyy': 'dd/LL/yyyy',
  'dd/mm/yy': 'dd/LL/yy',
  'LLL d, yyyy': 'LLL d, yyyy',
};

export const TIME_TRACKING_FILTER_VIEW_FIELDS = [
  {
    field: 'users',
    defaultValue: [],
  },
  {
    field: 'projects',
    defaultValue: [],
  },
  {
    field: 'costcodes',
    defaultValue: [],
  },
  {
    field: 'timeTypes',
    defaultValue: [],
  },
];

export const TIME_TRACKING_GRID_EXTRA_FILTER_VIEW_FIELDS = [
  {
    field: 'costcodes',
    defaultValue: [],
  },
  {
    field: 'timeTypes',
    defaultValue: [],
  },
];

export const FORM_FILTER_VIEW_FIELDS = [
  {
    field: 'users',
    defaultValue: [],
  },
  {
    field: 'projects',
    defaultValue: [],
  },
  {
    field: 'customers',
    defaultValue: [],
  },
  {
    field: 'equipment',
    defaultValue: [],
  },
  {
    field: 'buckets',
    defaultValue: [],
  },
];

export const BOARD_CARD_FILTER_VIEW_FIELDS = [
  {
    field: 'users',
    defaultValue: [],
  },
  {
    field: 'projects',
    defaultValue: [],
  },
  {
    field: 'statuses',
    defaultValue: [],
  },
];
